// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    /* max-height: calc(100vh - 365px); */
    overflow: auto;
}

table {
    overflow: auto;
    border-collapse: collapse;
    width: 100%;
}

.table-spec {
    width: 100%;
    max-width: 100%;
    empty-cells: show;
    border: 0;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    font-weight: normal;
}

td {
    padding: 6px 10px;
}

th {
    border-top: none;
    position: sticky;
    top: 0;
    padding: 10px;
    background: #212529;
    color: #ffffff;
    font-size: 14px;
    z-index: 1;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}

.first td:nth-child(1) {
    color: teal;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNob3ctbW9yZS1pbmZvcm1hdGlvbi5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0kscUNBQXFDO0lBQ3JDLGNBQWM7QUFDbEI7O0FBRUE7SUFDSSxjQUFjO0lBQ2QseUJBQXlCO0lBQ3pCLFdBQVc7QUFDZjs7QUFFQTtJQUNJLFdBQVc7SUFDWCxlQUFlO0lBQ2YsaUJBQWlCO0lBQ2pCLFNBQVM7QUFDYjs7QUFFQTtJQUNJLHlCQUF5QjtJQUN6QixnQkFBZ0I7SUFDaEIsbUJBQW1CO0FBQ3ZCOztBQUVBO0lBQ0ksaUJBQWlCO0FBQ3JCOztBQUVBO0lBQ0ksZ0JBQWdCO0lBQ2hCLGdCQUFnQjtJQUNoQixNQUFNO0lBQ04sYUFBYTtJQUNiLG1CQUFtQjtJQUNuQixjQUFjO0lBQ2QsZUFBZTtJQUNmLFVBQVU7QUFDZDs7QUFFQTtJQUNJLHlCQUF5QjtBQUM3Qjs7QUFFQTtJQUNJLHNCQUFzQjtBQUMxQjs7QUFFQTtJQUNJLGlDQUFpQztBQUNyQzs7QUFFQTtJQUNJLFdBQVc7QUFDZiIsImZpbGUiOiJzaG93LW1vcmUtaW5mb3JtYXRpb24uY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi50YWJsZS1jb250YWluZXIge1xyXG4gICAgLyogbWF4LWhlaWdodDogY2FsYygxMDB2aCAtIDM2NXB4KTsgKi9cclxuICAgIG92ZXJmbG93OiBhdXRvO1xyXG59XHJcblxyXG50YWJsZSB7XHJcbiAgICBvdmVyZmxvdzogYXV0bztcclxuICAgIGJvcmRlci1jb2xsYXBzZTogY29sbGFwc2U7XHJcbiAgICB3aWR0aDogMTAwJTtcclxufVxyXG5cclxuLnRhYmxlLXNwZWMge1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbiAgICBtYXgtd2lkdGg6IDEwMCU7XHJcbiAgICBlbXB0eS1jZWxsczogc2hvdztcclxuICAgIGJvcmRlcjogMDtcclxufVxyXG5cclxudGQsIHRoIHtcclxuICAgIGJvcmRlcjogMXB4IHNvbGlkICNkZGRkZGQ7XHJcbiAgICB0ZXh0LWFsaWduOiBsZWZ0O1xyXG4gICAgZm9udC13ZWlnaHQ6IG5vcm1hbDtcclxufVxyXG5cclxudGQge1xyXG4gICAgcGFkZGluZzogNnB4IDEwcHg7XHJcbn1cclxuXHJcbnRoIHtcclxuICAgIGJvcmRlci10b3A6IG5vbmU7XHJcbiAgICBwb3NpdGlvbjogc3RpY2t5O1xyXG4gICAgdG9wOiAwO1xyXG4gICAgcGFkZGluZzogMTBweDtcclxuICAgIGJhY2tncm91bmQ6ICMyMTI1Mjk7XHJcbiAgICBjb2xvcjogI2ZmZmZmZjtcclxuICAgIGZvbnQtc2l6ZTogMTRweDtcclxuICAgIHotaW5kZXg6IDE7XHJcbn1cclxuXHJcbnRib2R5IHRyOm50aC1jaGlsZChldmVuKSB7XHJcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjJmMmYyO1xyXG59XHJcblxyXG50ZCAudHh0YXJlYSB7XHJcbiAgICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xyXG59XHJcblxyXG50ZCB0ZXh0YXJlYTpob3ZlciB7XHJcbiAgICBib3JkZXI6IDFweCBzb2xpZCBncmF5ICFpbXBvcnRhbnQ7XHJcbn1cclxuXHJcbi5maXJzdCB0ZDpudGgtY2hpbGQoMSkge1xyXG4gICAgY29sb3I6IHRlYWw7XHJcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/View/core/analyze-sample/show-more-information/show-more-information.component.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;AACA,w9DAAw9D","sourcesContent":[".table-container {\r\n    /* max-height: calc(100vh - 365px); */\r\n    overflow: auto;\r\n}\r\n\r\ntable {\r\n    overflow: auto;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.table-spec {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    empty-cells: show;\r\n    border: 0;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n\r\ntd {\r\n    padding: 6px 10px;\r\n}\r\n\r\nth {\r\n    border-top: none;\r\n    position: sticky;\r\n    top: 0;\r\n    padding: 10px;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n    color: teal;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
